import { FC, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSuccessfulUpdateSnackbar, useFailedUpdateSnackbar, LoadingIndicator, ApiError } from "../../../../Components/CoreLib/library";
import { MiscLineItemForm } from "../../../../Components/Forms/QuoteForm";
import { MiscLineItemDto } from "../../../../dtos";
import { useLazyGetQuoteByIdQuery, useGetMiscLineItemByIdQuery, useUpdateMiscLineItemMutation } from "../../../../store/generated/generatedApi";


export const EditMiscLineItemView: FC = () => {
    const { quoteId, lineItemId } = useParams();
    const navigate = useNavigate();
    const [getQuote, { data: quote, isLoading: isQuoteLoading }] = useLazyGetQuoteByIdQuery();
    const { data, isLoading, error, refetch } = useGetMiscLineItemByIdQuery({ id: lineItemId! });
    const [updateMiscLineItem, { isSuccess, isError, reset }] = useUpdateMiscLineItemMutation();

    useEffect(() => {
        if (quoteId && !quote) {
            getQuote({ id: quoteId! });
        }
    }, [quote, quoteId, getQuote]);

    useSuccessfulUpdateSnackbar('Misc Line Item', isSuccess, () => {
        if (quoteId) {
            navigate(`/quote/${quoteId}/lineItems`);
        } else {
            navigate(`/quotes`);
        }
    });
    useFailedUpdateSnackbar('Misc Line Item', isError, reset);

    const handleSave = (values: MiscLineItemDto) => {
        updateMiscLineItem(values);
    };

    const handleCancel = () => {
        if (quoteId) {
            navigate(`/quote/${quoteId}/lineItems`)
        } else {
            navigate(`/quotes`);
        }
    };

    if (isLoading || isQuoteLoading) {
        return <LoadingIndicator />;
    }

    if (error) {
        return <ApiError onReloadClick={refetch} />;
    }

    return <MiscLineItemForm save={handleSave} cancel={handleCancel} initValues={data} quote={quote} />;
};
